<template>
  <div class="OACustomer">
    <!-- <OATop></OATop> -->
    <div class="OATop" style="height:auto;">
      <div>
        <ShowNavHead />
      </div>
      <div class="OATopLeft" style="width: 85%;margin-left:10px;flex-wrap: wrap;-webkit-flex-wrap: wrap;">
        <div class="OAScreenInput">
          <div>服务中心</div>
          <el-select v-model="infoQuery.strsrvcent" clearable placeholder="请输入或选择" filterable @change="serviceChange">
              <el-option 
              v-for="(item,index) in serviceList"
              :key="index"
              :label="item.StrSrvCent"
              :value="item.StrSrvCent"></el-option>
            </el-select>
        </div>
        <div class="OAScreenInput">
          <div style="width:80px">项目名称</div>
          <el-input v-model.trim="infoQuery.objname" placeholder="请输入项目名称" @keyup.enter.native="searchEnterFun"></el-input>
          <!-- <el-select v-model="infoQuery.objname" placeholder="请输入或选择" filterable>
            <el-option 
              v-for="(item,index) in objList"
              :key="index"
              :label="item.StrObjName"
              :value="item.StrObjName"></el-option>
          </el-select> -->
        </div>
        <div class="OAScreenInput">
          <div>服务状态</div>
          <el-select v-model="infoQuery.strbusistat" slot="prepend" clearable placeholder="请输入或选择" @change="selHandle" filterable>
            <el-option
              v-for="(item,index) in stateList"
              :key="index"
              :label="item.strbusistat"
              :value="item.strbusistat"></el-option>
          </el-select>
        </div>
        <div style="margin-left:10px">
          <el-button type="success" plain size="small" class="c_search" @click="serarchHandle()">搜索</el-button>
          <el-button plain size="small" @click="resetHandle()" style="margin-left:10px">清空</el-button>
          <!-- <el-button type="primary" plain size="small" style="margin-left:10px">导出</el-button> -->
        </div>
      </div>
      <div>
        <el-button type="success" plain size="small" class="c_search" style="margin-right:20px;" @click="syncOA" v-show="this.loginRoletype.indexOf('admin')>-1">从OA中同步</el-button>
      </div>

      <el-dialog title="从OA中同步" :visible.sync="dialogVisible" width="384px">
        <div>同步过程可能需要几分钟，请耐心等待</div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible = false">取消</button>
          <button
            class="search"
            @click="confirmSync"
            style="margin-left:10px;font-weight:600"
            type="primary"
            v-loading.fullscreen.lock="fullscreenLoading"
            element-loading-text="同步中"
          >立即同步</button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="dialogVisible6" width="480px">
        <div style="height:1px"></div>
        <div class="successBox">
          <div class="successImg">
            <img src="../../assets/employee/images/success.png" />
          </div>
          <div class="successText" style="height:25px">同步成功</div>
          <div class="importNum" style="height:25px">新增3条客户信息</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible6 = false">完成</button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="dialogVisible7" width="480px">
        <div style="height:1px"></div>
        <div class="successBox">
          <div class="successImg">
            <img src="../../assets/employee/images/failed.png" />
          </div>
          <div class="successText" style="height:25px">同步失败</div>
          <div class="importNum" style="height:25px">中断原因：网络异常</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible7 = false">关闭</button>
          <button
            class="search"
            @click="dialogVisible7 = false"
            style="margin-left:10px;font-weight:600"
          >重新同步</button>
        </span>
      </el-dialog>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>OA客户管理</el-breadcrumb-item>
          <el-breadcrumb-item>客户列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button type="success" plain size="small" class="c_search" style="margin-right:0;" @click="changeSelectState()">批量更改客户客服</el-button>
      </div>
      <div class="OACustomerTable">
        <el-table :data="tableData" :max-height="tableHeight-180" v-loading="listLoading" stripe @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="40"></el-table-column>
          <!-- <el-table-column align="center" label="序号" prop="serialNumber" width="50"></el-table-column> -->
          <el-table-column align="center" label="序号" width="60px">
            <template slot-scope="scope">
                <span>{{(infoQuery.currpage - 1) * infoQuery.pagecount + scope.$index + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="服务中心" prop="StrSrvCent" min-width="120px"></el-table-column>
          <el-table-column align="center" label="公司" prop="StrBlCmp" min-width="120px"></el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName"></el-table-column>
          <el-table-column align="center" label="项目类别" prop="StrProjectType"></el-table-column>
          <el-table-column align="center" label="业务立项部门" prop="StrObjInstName" min-width="130px"></el-table-column>
          <el-table-column align="center" label="负责客服" prop="StrUserName"></el-table-column>
          <el-table-column align="center" sortable label="雇员总数" prop="employeesNum"></el-table-column>
          <el-table-column align="center" label="服务状态" prop="StrBusiStat"></el-table-column>
          <el-table-column align="center" fixed="right" label="操作" min-width="200px">
            <template slot-scope="scope">
              <el-button type="warning" plain size="mini" class="c_state" @click="changeState(scope.row)">更改状态</el-button>
              <el-button type="success" plain size="mini" class="c_search" @click="changeServe(scope.row)">更改客服</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount>0">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="更改服务状态" :visible.sync="dialogVisible2" width="384px">
      <span>服务状态</span>
      <div class="contractType2">
        <el-select v-model="editStrBusiStat" slot="prepend" placeholder="请选择" filterable>
          <el-option 
              v-for="(item,index) in stateList"
              :key="index"
              :label="item.strbusistat"
              :value="item.strbusistat"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="dialogVisible2 = false">取消</button>
        <button
          class="search"
          @click="stateSubmit"
          style="margin-left:10px;font-weight:600"
        >确定</button>
      </span>
    </el-dialog>

    <el-dialog title="更改客服" :visible.sync="dialogVisible3" width="384px">
      <div class="contractType2">
        <el-select
          v-model="editCusQuery.strUserName"
          slot="prepend"
          placeholder="请选择客服"
          filterable
          clearable
          @change="selectSubordinate"
        >
          <el-option
            v-for="(item, index) in subordinateList"
            :key="index"
            :label="item.Username"
            :value="{value:item.Userid,label:item.Username}"
          ></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-popover
        placement="top"
        width="160"
        v-model="dltvisible">
        <p>是否确定解除绑定客服？</p>
        <div style="text-align: right; margin-top:8px">
          <el-button size="mini" type="default" @click="dltvisible = false">取消</el-button>
          <el-button type="primary" size="mini" @click="unbindHandle">确定</el-button>
        </div>
        <el-button slot="reference" size="small" type="success" style="margin-right:10px" v-show="!isNull(editCusQuery.strUserName)">解绑客服</el-button>
      </el-popover>
        <button class="clear" @click="dialogVisible3 = false">取消</button>
        <button
          class="search"
          @click="cusSubmit"
          style="margin-left:10px;font-weight:600"
        >确定</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xz from "@/common";
import OATop from "./components/OATop";
export default {
  components: {
    OATop
  },
  data() {
    return {
      dltvisible:false,
      tableHeight:0,
      pageSize:10,
      listLoading:false,
      serviceStatus: "",
      currentPage: 1,
      pageSize:10,
      dialogVisible2: false,
      dialogVisible3: false,
      tableData: [],
      //下级人员列表
      subordinateList: [],
      //已选择的下级
      selectedSubordinate: null,
      pagecount:10,
      //第几页
      currpage: 1,
      //数据数量
      totalcount: null,
      fullscreenLoading: false,
      select: "",
      //同步OA
      dialogVisible:false,
      //同步失败
      dialogVisible7:false,
      //同步成功
      dialogVisible6:false,
      //下拉服务中心列表
      serviceList:[],
      //下拉项目名称
      objList:[],
      //下拉服务状态
      stateList:[
        {strbusistat:'合作中'},
        {strbusistat:'暂停合作'},
        {strbusistat:'终止合作'}
        ],
      //列表参数
      infoQuery:{
        pagecount:10,
        currpage:1,
        objname:"",//项目名称
        ctluserid:"",
        strsrvcent:"",//服务中心
        strobjinstname:"",//立项部门
        strusername:"",//客服名称
        strbusistat:"",//服务状态
        stremptype: "0"
      },
      //修改服务状态(弹窗)
      editStrBusiStat:'',
      gdObjId:'',
      //修改客服
      editCusQuery:{
        action: "save",
        pagename: "updateEmpCustListgdUserId",
        gdObjIds:'',
        gdUserId: '',
        strUserName:''
      },
      //选中状态值（多个客服）
      multipleSelection:[],
      multipleIDs:'',
      isSelect:false,
      //登录角色
      loginRoletype:'',
      loginIDTxt:'',
      // 员工参数
      departMemberQuery:{
        currpage: 1,
        perpage: 10000,
        strWorkState:'在职',
        keyword:''
      },
      departQuery:{
          strorgancode:'',
          roletype:''
        }
    }
  },
  async created() {
    this.departQuery.roletype = localStorage.loginRoletype
    this.departQuery.strorgancode = localStorage.gancode
    this.loginIDTxt = Cookies.get("userid-b")
    this.calHeight();
    this.loginMemberHandle()
    this.getCustomerList();
    this.getServiceList()
    // this.getObjList()
    this.getMemberList()
    // xz.groupMember(Cookies.get("userid-b")).then(member => {
    //   if (member && Array.isArray(member)) {
    //     member.forEach(m => {
    //       this.subordinateList.push({
    //         value: m.id,
    //         label: m.userName,
    //         mobile: m.usermobile
    //       });
    //     });
    //   } else {
    //     this.subordinateList = [];
    //   }
    // });
  },
  methods: {
    // 客户信息弹窗
    customerInfoHandle(){
      this.customerVisible = true
    },
    // 项目信息弹窗
    proInfoHandle(){
      this.proVisible = true
    },
    // 保存客户信息
    saveCustomerHandle(){
      this.customerVisible = false
    },
    // 保存项目信息
    saveProHandle(){
      this.proVisible = false
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight);
      console.log('height',this.tableHeight) 
    },

    handleCurrentChange(val) {
      this.infoQuery.currpage = `${val}`;
      this.getCustomerList();
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.infoQuery.pagecount = `${val}`;
        this.pageSize = parseInt(val);
        this.getCustomerList();
    },
    //登陆详情
    loginMemberHandle() {
      xz.getUserDetail(this.loginIDTxt).then(res => {
        console.log('成员详情',res)
        if (res.status == 'ok') {
          this.loginRoletype = res.msg.Roletype
        }
      });
    },
    //搜索
    searchEnterFun(){
      this.getCustomerList();
    },
    //下拉筛选-服务状态
    selHandle(val){
      this.infoQuery.strbusistat = val
      this.getCustomerList();
    },
    //下拉筛选-服务状态
    selHandle(val){
      this.infoQuery.strbusistat = val
      this.getCustomerList();
    },
    //选中值
    handleSelectionChange(val) {
      // console.log('选中值',val)
      this.multipleSelection = []
      if(val && Array.isArray(val)){
        for (let index = 0; index < val.length; index++) {
          const elementVal = val[index];
          this.multipleSelection.push(
            elementVal.GdObjId)
        }
      }
      // console.log('选中值',this.multipleSelection)
    },
    //判断是否为空(包含0)
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0
    },
    getCustomerList() {
      // console.log('ss',this.infoQuery)
      this.listLoading = true
      xz.customerInfo(this.infoQuery).then(res => {
        // console.log('ss',res)
        this.tableData = res.data;
        this.totalcount = parseInt(res.totalcount);
        this.listLoading = false
      });
    },
    //更改选中客户选中状态
    changeSelectState(){
      console.log('选中值',this.multipleSelection)
      if(this.multipleSelection == []||this.multipleSelection.length==0){
        this.$message({
          showClose: true,
          message: "请选择表格中需要批量更改的数据",
          type: "warning"
        });
        return false
      }else{
        this.dialogVisible3 = true
        this.isSelect = true
        this.editCusQuery = {
          gdObjIds:'',
          gdUserId: '',
          strUserName:''
        }
        this.multipleIDs = this.multipleSelection.toString()
      }
    },
    //下级人员列表
    getMemberList(){
      //获取下级人员列表
      xz.GetUserInfoBytopuser(this.departQuery.strorgancode,this.departQuery.roletype,this.departMemberQuery).then(res => {
        // console.log('下级人员列表',res)
        if (res.msg && Array.isArray(res.msg)) {
          this.subordinateList = res.msg;
        } else {
          this.subordinateList = [];
        }
      });
    },
    serviceChange(val){
      this.infoQuery.strsrvcent = val
      this.getCustomerList();
      // this.getObjList(this.infoQuery.strsrvcent)
    },
    //修改服务状态
    stateSubmit(){
      if(this.editStrBusiStat==''||this.editStrBusiStat==null){
         this.$message({
            message: "请选择服务状态",
            type: "warning"
          });
          return false
      }else{
          xz.updateEmpCustListstrBusiStat(this.gdObjId,this.editStrBusiStat).then(res => {
            // console.log('修改服务状态',res,this.gdObjId,this.editStrBusiStat)
           if(res.status == 'ok'){
              this.getCustomerList()
              this.$message({
                message: "修改成功",
                type: "success"
              });
              this.dialogVisible2 = false
            }else{
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          })
      }
    },
    //修改客服状态
    cusSubmit(){
      // if(this.editCusQuery.gdUserId==''||this.editCusQuery.gdUserId==null){
      //    this.$message({
      //       message: "请选择客服状态",
      //       type: "warning"
      //     });
      //     return false
      // }else{
        if(this.isSelect == true){
          this.editCusQuery.gdObjIds = this.multipleIDs
        }
        // console.log('gg',this.editCusQuery)
        xz.updateEmpCustListgdUserId(this.editCusQuery.gdObjIds,this.editCusQuery.gdUserId,this.editCusQuery.strUserName).then(res => {
          // console.log('修改客服状态',res)
          if(res.status == 'ok'){
            this.dltvisible = false
            this.dialogVisible3 = false
            this.$message({
              message: "修改成功",
              type: "success"
            });
            this.getCustomerList()
          }else{
              this.$message({
                message: res.msg,
                type: "error"
              });
          }
        });
      // }
    },
     //下拉服务中心列表
    getServiceList(){
      xz.getsrarchinstlist().then(res => {
        // console.log("getServeList", res);
        let dataList = []
        if(res && res.length>0){
          for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({StrSrvCent:service.Strinstname})
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
        }else{
          this.serviceList = []
        }
      });
    },
    //下拉项目名称
    getObjList(strsrvcent){
      xz.getsrarchinstobjlist(strsrvcent).then(res => {
        // console.log("getApartmentList", res);
        let dataList = []
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          if(apartmentData.StrObjName!=''&&apartmentData.StrObjName!=' '){
            dataList.push({StrObjName:apartmentData.StrObjName})
          }
        }
        // console.log("getServeList", dataList);
        this.objList = dataList;
      });
    },
    //清空
    resetHandle(){
      this.infoQuery = {
        pagecount:window.localStorage.getItem('page')?window.localStorage.getItem('page'):10,
        currpage:1,
        objname:"",//项目名称
        ctluserid:"",
        strsrvcent:"",//服务中心
        strobjinstname:"",//立项部门
        strusername:"",//客服名称
        strbusistat:"" //服务状态
      }
    },
    //搜索
    serarchHandle(){
      this.infoQuery.currpage = 1
      this.getCustomerList()
    },
    // 下拉选择人员
    selectSubordinate(d) {
      this.editCusQuery.gdUserId = d.value
      this.editCusQuery.strUserName = d.label
      // console.log("d", d);
    },
    //解绑客服
    unbindHandle(){
      this.editCusQuery.gdUserId = ''
      this.editCusQuery.strUserName = ''
      this.cusSubmit()
    },
    changeState(item) {
      // console.log(item);
      this.editStrBusiStat = item.StrBusiStat
      this.gdObjId = item.GdObjId
      this.dialogVisible2 = true;
    },
    changeServe(item) {
      // console.log(item);
      this.isSelect = false
      this.editCusQuery.gdObjIds = item.GdObjId
      this.editCusQuery.gdUserId = item.GdUserId
      this.editCusQuery.strUserName = item.StrUserName
      this.dialogVisible3 = true;
    },
    syncOA(){
      this.dialogVisible = true;
    },
    confirmSync(){
       this.fullscreenLoading = true;
      //   setTimeout(() => {
      //     this.fullscreenLoading = false;
      //      this.dialogVisible7=true;
      //   }, 2000);
      // var q = Cookies.get("userid-b");
      xz.syncFromOA().then(res=>{
        // console.log('oa',res)
        if(res==true){
          this.$message({
            message: "OA同步成功！",
            type: "success"
          });
           this.fullscreenLoading = false;
           this.dialogVisible = false;
           this.getCustomerList();
        }else{
          this.$message.error(res);
          this.fullscreenLoading = false;
          this.dialogVisible = false;
        }
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
.pro-form-inline .el-input__inner,.pro-form-inline .el-date-editor.el-input{
  width: 250px;
}
.OACustomer .c_txt{
  color: #19BD92;
}
.OACustomer .c_state.el-button--warning.is-plain{
  color: #F78500;
  background: #fff;
  border-color: #F78500;
}
.c_state.el-button--warning.is-plain:focus, .c_state.el-button--warning.is-plain:hover{
  color: #F78500;
  background: #fff;
  border-color: #F78500;
}
.OACustomer .c_search.el-button--success.is-plain{
    color: #19BD92;
    background: #ebfaf5;
    border-color: #62d2b4;
}
.c_search.el-button--success.is-plain:focus, .c_search.el-button--success.is-plain:hover {
    background: #ebfaf5;
    border-color: #19BD92;
    color: #19BD92;
}
.contractType2 .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 336px;
  margin-top: 10px;
}
.contractType2 .el-input__icon {
  height: 32px;
  line-height: 32px;
  margin-top: 10px;
}

.OACustomerTable .el-table th > .cell {
  padding: 0;
}
.OACustomerTable .el-table .cell {
  padding: 0;
}
.OACustomerTable .el-table td {
  padding: 6px 0;
}
.OACustomerTable .el-table th {
  padding: 6px 0;
}
.OAScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-left: 10px;
  /* margin-top: 10px; */
}
.OAScreenInput .el-input__icon {
  /* margin-top: 10px; */
  height: 32px;
  line-height: 32px;
}
.screenAndExport .el-button {
  padding: 0;
  margin-right: 20px;
}
.OATop .el-dialog__body{
  padding: 0 20px;
}
.OATop .el-dialog__header{
  padding: 0 20px;
}
.OATop .el-dialog__footer{
  padding: 0 20px;
}
</style>